import { useState } from "react";
import { useTranslation } from "react-i18next";

const languageOrder = ["en", "fr", "de", "es", "pt"] as const;

const flagEmoji: Record<string, string> = {
  en: "🇬🇧",
  fr: "🇫🇷",
  de: "🇩🇪",
  es: "🇪🇸",
  pt: "🇵🇹",
};

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const currentLang = (i18n.language ?? "en").split("-")[0];

  const handleSelect = (lang: string) => {
    i18n.changeLanguage(lang);
    setOpen(false);
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300/60 bg-background-50 px-3 py-2 text-sm font-medium text-foreground-800 hover:bg-background-100 cursor-pointer transition-colors"
        aria-label={t("lang.label")}
      >
        <span className="text-base leading-none">{flagEmoji[currentLang] ?? "🌐"}</span>
        <span className="hidden sm:inline">{t(`lang.${currentLang}`)}</span>
        <i className="ri-arrow-down-s-line text-foreground-500 text-sm"></i>
      </button>

      {open && (
        <div className="absolute right-0 z-50 mt-2 w-44 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {languageOrder.map((lang) => (
            <button
              key={lang}
              type="button"
              onClick={() => handleSelect(lang)}
              className={`flex w-full items-center gap-2 whitespace-nowrap px-4 py-2.5 text-left text-sm transition-colors cursor-pointer hover:bg-primary-100 ${
                currentLang === lang
                  ? "font-semibold text-primary-700"
                  : "text-foreground-700"
              }`}
            >
              <span className="text-base leading-none">{flagEmoji[lang]}</span>
              <span>{t(`lang.${lang}`)}</span>
              {currentLang === lang && (
                <i className="ri-check-line ml-auto text-primary-600"></i>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}